export function useAddressResolver() {
  let latLngResolverTimeouts = {};
  function findLatLngByAddress(address, id = 1) {
    return new Promise((resolve, reject) => {
      let countryCode = address.country_code ?? null;
      let postcode = address.postcode ?? null;
      let city = address.city ?? null;
      let street = address.street ?? null;
      if (latLngResolverTimeouts[id]) {
        clearTimeout(latLngResolverTimeouts[id]);
      }
      if (!countryCode?.length && !postcode?.length && !city?.length && !street?.length) {
        resolve(null);
        return;
      }
      latLngResolverTimeouts[id] = setTimeout(() => {
        $fetch("https://nominatim.openstreetmap.org/search", {
          method: "GET",
          params: {
            format: "json",
            limit: 1,
            country: countryCode,
            city,
            street,
            postalcode: postcode
          }
        }).then((result) => {
          if (Array.isArray(result) && result.length > 0) {
            result = result[0];
            result.lng = result.lon;
            resolve(result);
          } else {
            resolve(null);
          }
        }).catch(() => {
          const country = countryCode ? countryCode : "";
          postcode = postcode ? postcode + ", " : "";
          city = city ? city + ", " : "";
          street = street ? street + ", " : "";
          const fullAddress = street + postcode + city + country;
          $fetch({
            method: "GET",
            url: "https://maps.googleapis.com/maps/api/geocode/json",
            params: {
              key: "AIzaSyAbEt9Cx_p9x0JEmpdsAtYb0Ecf12It4ok",
              address: fullAddress
            }
          }).then((result) => {
            resolve(Array.isArray(result) && result.length > 0 ? result[0].geometry.location : null);
          }).catch(() => {
            reject();
          });
        });
      }, 1e3);
    });
  }
  return {
    findLatLngByAddress
  };
}
